import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import _ from 'lodash';
import shared from '../utils/shared.js';

import { connect } from 'react-redux';
import { switchModule, setOptions } from '../actions/display';
import { getFileType, dpath, videoType, parseStringParam } from '../utils/shared';
import cfg from '../../config.js';

//components
import Story from '../Components/Story/Story';
import Stories from '../Components/Story/Stories';
import DonorList from '../Components/Donor/DonorList';
import DonorListPassive from '../Components/Donor/DonorListPassive';
import UserInput from '../Components/UserInput/UserInput';
import InputConfirmation from '../Components/UserInput/InputConfirmation';
import Slideshow from '../Components/Slideshow/Slideshow';
import RecentDonors from '../Components/Donor/RecentDonors';
import Timeline from '../Components/Timeline/Timeline';
import TimelineChicago from '../Components/Theme/Chicago/TimelineChicago';
import Search from '../Components/Search/Search';
import Results from '../Components/Search/Results';
import TestMin2 from '../Components/Test/TestMin2';
import NavigationSide from '../Components/Navigation/NavigationSide';
import NavButton from './NavButton';
import AttractLoopContainer from '../Components/Theme/Chicago/AttractLoopContainer';
import DonorListChicago from '../Components/Theme/Chicago/DonorListChicago';
import DonorListChicagoSimple from '../Components/Theme/Chicago/DonorListChicagoSimple';
import StoriesFoldersChicago from '../Components/Theme/Chicago/StoriesFoldersChicago';
import NavBottomFixed from '../Components/Navigation/NavBottomFixed';
import InteractBottomFixed from '../Components/Navigation/InteractBottomFixed';
import sailsIOClient from 'sails.io.js';
import socketIOClient from 'socket.io-client';


const _videoStyle = {
  preload: 'auto',
  position: 'fixed',
  minWidth: '100%',
  minHeight: '100%',
  width: 'auto',
  height: 'auto',
  zIndex: -100,
  loop: '',
  autoplay: "",
  muted: "",
  pointerEvents: "none"
}
const recent_interaction_timeout = 5000;
const FOLDER_ATTRACT = "folder";
const LEGACY_ATTRACT = "legacy";

class DisplayContainer extends Component {
  constructor(props) {
    super(props);
    this._contentInterval = null;
    this._donorsInterval = null;
    this._useFolders = false;
    // this.navroute = this.navroute.bind(this);
    this.navback = this.navback.bind(this);
    this.handleNavigationSlide = this.handleNavigationSlide.bind(this);
    this.toggleSlideOn = this.toggleSlideOn.bind(this);
    this.toggleSlideOff = this.toggleSlideOff.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this._videoModalRef = null;
    this._audioRef = null;
    this._assetFile = null;
    this._audioAssetFile = null;
    this._attractLoopMode = null;

    this.idleRef = 0;
    this._idleLoopTimeout = null;
    this._announcementAsset = null;
    this._announcementAudioAsset = null;
    this._announcementTimeout = null;
    this._recentInteractionTimeout = null;
    this.lastInteraction = new Date();
    this._attractLoopTree = {};
    // this.setupElements();

    this.state = {
      displayNav: false,
      options: {},
      idle: false,
      recentInteraction: false,
      navback: {},
      showNav: true,
      donorsInit: false,
      showModal: false,
      showModalVideo: false,
      showClock: true,
      module: {},
      otherModules: [],
      attractLoopRef: 0
    }
  }

  componentDidMount() {
    // Socket Subscribe and event binding.
    let socketsEnabled = _.get(cfg, 'sockets.enabled', false);
    if (socketsEnabled) {
      this.websocketHandler();
    }

    document.addEventListener("keydown", this.handleKeyDown);
    if (this.props.jumpToModule === true) {
      this.navroute(null, null, "jumpto", { routeoverride: this.props.routeoverride });
    }

    if (this.props.content.idle_delay) {
      this._idleDelay = this.props.content.idle_delay * 1000;
    }
    else {
      this._idleDelay = 120000;
    }

    // Idle interaction Attract Loop.
    if (this.props.idleActive) {
      if (this.props.content.idle_delay > 0) {
        if (!this.props.content.settings.disallowInteraction) {
          window.addEventListener('mousedown', this.pageClick, false);
        }
        // Check if folder Attract Loop or Legacy
        let folderAttractLoop = _.get(this.props.content.settings, 'folderAttractLoop', false);
          let topAttractLoop = _.filter(this.props.content.story_categories, { parent_category: null, contents: { custom_fields: { folder_type: { val: { value: "attract_loop" } } } } });
        topAttractLoop = topAttractLoop[0];
        const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
        
        // console.log(folderAttractLoop);
        if (folderAttractLoop) {
          // console.log(rootFolderId);
          if (rootFolderId) {
            const rootFolder = this.props.content.story_categories.find(f => f.id === Number(rootFolderId));
            const rootFolderType = _.get(rootFolder, 'contents.custom_fields.folder_type.val.value', null);
            if (rootFolderType && rootFolderType.includes("attract_loop")) {
              topAttractLoop = rootFolder;
            }
          }
          this._attractLoopMode = LEGACY_ATTRACT;
          // console.log(topAttractLoop);
          if (topAttractLoop) {
            this._attractLoopMode = FOLDER_ATTRACT;
            this._attractLoopTree = shared.createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, null, this.props.content.stories, this.props.content.dm_active, topAttractLoop.name, 'contents.sorting_date', 'desc');

            // console.log(this._attractLoopTree);
            this.props.setOptions({
              attractLoopTree: this._attractLoopTree
            });

            this.folderCheckRecentInteraction();
            this.checkIdleTimeout();
            this.folderGoIdle("idle");
          }
        } else {
          this._attractLoopMode = LEGACY_ATTRACT;
          this.checkRecentInteraction();
          this.checkIdleTimeout();
          this.goIdle("idle");
        }
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    clearInterval(this._contentInterval);
    clearInterval(this._donorsInterval);
    window.removeEventListener('mousedown', this.pageClick, false);
    clearTimeout(this._idleTimeout);
    clearTimeout(this._recentInteractionTimeout);
    clearTimeout(this._audioCycle);
  }

  setupElements = () => {
    let announcementModule = _.find(this.props.content.dm_active, { display_module_type: "Announcement" });
    if (announcementModule) {
      let asset = _.get(announcementModule.contents, "images[0]", null);
      if (asset) {
        this._assetFile = asset.file_name;
      }

      let announcementAudioAsset = _.get(announcementModule.contents, "images[1]", null);
      if (announcementAudioAsset) {
        this._audioAssetFile = announcementAudioAsset.file_name;
      }
      this._announcementAsset = shared.dp(this.props.screen, asset);
      this._announcementAudioAsset = shared.dp(this.props.screen, announcementAudioAsset);

      this._announcementTimeout = Number(announcementModule.contents.timeout) * 1000;
    }
  }

  goIdle = (type) => {
    if (type === "recentInteraction") {
      this.setState({
        recentInteraction: false
      })
    }
    else {
      this.toggleShowClock(true);
      // console.log("Go idle")
      this.setState({
        idle: true
      })
      if (this.props.content.display_module_loops[0]) {
        this.cycleIdle();
        this.cycleIdleLoop();
      }
    }
  }

  folderGoIdle = (type) => {
    if (type === "recentInteraction") {
      this.setState({
        recentInteraction: false
      })
    }
    else {
      this.toggleShowClock(true);
      this.props.history.replace("/");
      // console.log("Go idle")
      this.setState({
        idle: true
      });

      this.folderCycleIdle();
      this.folderCycleIdleLoop();
    }
  }

  websocketHandler = () => {
    let displayId = this.props.content.id;
    this._io = sailsIOClient(socketIOClient);

    this._io.sails.autoConnect = true;
    this._io.sails.url = cfg.WEB_SERVER;
    
    this._io.socket.on('email_announcement', (event) => {
      // console.log("Event triggered");
      this.setupAsset(event);
    });
    
    this._io.socket.on('connect', () => {
      this._io.socket.get(`/feed/subscribe?display=${displayId}`, function serverResponded(body, JWR) {
        // console.log('loaded');
      });
    });

    this._io.socket.on('error', (e) => {
      // console.log('error');
    });

    this._io.socket.on('disconnect', () => {
      this._io.socket._raw.io._reconnection = true;
    });
  }

  setupAsset = (event) => {
    let data = JSON.parse(event);
    if (data.subject && this.props.content.settings.announcement_modules) {
      let module = _.find(this.props.content.settings.announcement_modules, { subject: data.subject });
      if (module) {
        let announcementModule = _.find(this.props.content.dm_active, { id: module.id });
        if (announcementModule) {
          let asset = _.get(announcementModule.contents, "images[0]", null);
          if (asset) {
            this._assetFile = asset.file_name;
          }

          let announcementAudioAsset = _.get(announcementModule.contents, "images[1]", null);
          if (announcementAudioAsset) {
            this._audioAssetFile = announcementAudioAsset.file_name;
          }

          this._announcementAsset = shared.dp(this.props.screen, asset);
          this._announcementAudioAsset = shared.dp(this.props.screen, announcementAudioAsset);
          this._announcementTimeout = Number(announcementModule.contents.timeout) * 1000;

          this.showModal();
        }
      }
    }
  }

  cycleIdle = () => {
    if (this.idleRef >= this.props.content.display_module_loops[0].display_module_loop_units.length) {
      this.idleRef = 0
    }
    this.navroute(this.idleRef, this.props.content.display_module_loops[0].display_module_loop_units[this.idleRef].data.display_module_type, "idle", { idleModule: this.idleRef });
  }

  cycleIdleLoop = () => {
    clearTimeout(this._idleLoopTimeout);
    this._idleLoopTimeout = setTimeout(() => {
      this.cycleIdle();
      this.cycleIdleLoop();
    }, this.props.content.display_module_loops[0].display_module_loop_units[this.idleRef].cycle_time_seconds * 1000);
    this.idleRef++;
  }

  folderCycleIdle = () => {
    if (this.idleRef >= this._attractLoopTree.children.length) {
      this.idleRef = 0
    }
    let type = _.get(this._attractLoopTree.children[this.idleRef].contents, 'custom_fields.story_type.val.value', 'story');
    this.folderNavroute(this.idleRef, type, "idle", { idleModule: this.idleRef });
  }

  folderCycleIdleLoop = () => {
    clearTimeout(this._idleLoopTimeout);
    let timeout = Number(_.get(this._attractLoopTree.children[this.idleRef].contents, 'custom_fields.cycle_timeout.val', 30));
    this._idleLoopTimeout = setTimeout(() => {
      this.folderCycleIdle();
      this.folderCycleIdleLoop();
    }, timeout * 1000);
    this.idleRef++;
  }

  resume = () => {
    this.lastInteraction = new Date();
    if (this._attractLoopMode === LEGACY_ATTRACT) {
      this.checkRecentInteraction();
    } else {
      this.folderCheckRecentInteraction();
    }

    this.checkIdleTimeout();

    if (this.state.idle === true) {
      if (this._attractLoopMode === FOLDER_ATTRACT) {
        this.props.history.replace('/');
      }
      this.setState({
        idle: false
      })
      clearTimeout(this._idleLoopTimeout);
    }
    if (this.state.recentInteraction === false) {
      this.setState({
        recentInteraction: true
      })
    }
  }

  handleKeyDown(event) {
    switch (event.key) {
      case "s":
        console.log(this.props);
        break;
      case "i":
        this.goIdle();
        break;
      case "m":
        this.setupAsset(JSON.stringify({ subject: "baby" }));
        break;
      case "n":
        this.setupAsset(JSON.stringify({ subject: "baby_boy" }));
        break;
      case "b":
        this.setupAsset(JSON.stringify({ subject: "baby_girl" }));
        break;
      default:
        break;
    }

    if (this.state.idle) {
      clearTimeout(this._idleLoopTimeout);
      switch (event.keyCode) {
        case 37:
          if (this.idleRef < 2) {
            this.idleRef = this._attractLoopMode.children.length - 1;
          } else {
            this.idleRef = this.idleRef - 2;
          }
          this.folderCycleIdle();
          this.folderCycleIdleLoop();
          break;
        // Right Arrow (Next)
        case 39:
          this.folderCycleIdle();
          this.folderCycleIdleLoop();
          break;
        default:
          break;
      }
    }
  }

  handleNavigationSlide() {
    if (this.state.displayNav === false) {
      this.toggleSlideOn();
    }
    else {
      this.toggleSlideOff();
    }
  }

  handleImageLoaded = () => {
    if (this.state.showModal) {
      let height = this._imageModalRef.getBoundingClientRect().height;
      let width = this._imageModalRef.getBoundingClientRect().width;
      let offsetX = (this.props.screen.screenWidth / 2) - (width / 2);
      let offsetY = (this.props.screen.screenHeight / 2) - (height / 2);

      this._imageModalRef.style['left'] = offsetX + 'px';
      this._imageModalRef.style['top'] = offsetY + 'px';
    }
  }

  loadedMetadata = (event) => {
    let videoHeight = this._videoModalRef.getBoundingClientRect().height;
    let videoWidth = this._videoModalRef.getBoundingClientRect().width;
    let videoMaxHeight = 0;
    let videoMaxWidth = 0;
    let videoOffsetX = 0;
    let videoOffsetY = 0;
    let videoRatio = videoWidth / videoHeight;
    // let screenRatio = this.props.screen.screenWidth / this.props.screen.screenHeight;
    let isHorizontal = videoWidth > videoHeight;

    if (isHorizontal) {
      videoMaxWidth = this.props.screen.screenWidth;
      videoMaxHeight = videoMaxWidth / videoRatio;
    } else {
      videoMaxHeight = this.props.screen.screenHeight;
      videoMaxWidth = videoMaxHeight * videoRatio;
    }

    videoOffsetX = (videoMaxWidth < this.props.screen.screenWidth) ? (this.props.screen.screenWidth / 2) - (videoMaxWidth / 2) : 0;
    videoOffsetY = (videoMaxHeight < this.props.screen.screenHeight) ? (this.props.screen.screenHeight / 2) - (videoMaxHeight / 2) : 0;

    let videoControlsOffset = videoOffsetY + (videoHeight / 2);

    // console.log("Loaded Metadata");

    if (this._videoModalRef !== undefined && this._videoModalRef !== null) {
      let duration = this._videoModalRef.duration;
      // console.log("1- Setting a duration of", duration);
      this._modalCycle = setTimeout(() => {
        // console.log("Closing Modal");
        this.setState({
          showModalVideo: false
        });
      }, duration * 1000);
    } else {
      this.handleVideoDuration();
    }    

    this.setState({
      duration: event.target.duration,
      videoOffsetY: videoOffsetY,
      videoOffsetX: videoOffsetX,
      videoControlsOffset: videoControlsOffset,
      videoMaxHeight: videoMaxHeight,
      videoMaxWidth: videoMaxWidth,
      videoFile: this.props.content.file_path
    });
  }

  loadedAudioMetadata = (event) => {
    if (this._audioRef !== undefined && this._audioRef !== null) {
      let audioDuration = this._audioRef.duration;
      // console.log("Audio Duration", audioDuration);
      this._audioRef.volume = 1;
      clearTimeout(this._audioCycle);
      this._audioCycle = setTimeout(() => {
        this.setState({
          playAudio: false
        });
      }, audioDuration * 1000);
    } else {
      clearTimeout(this._audioCycle);
      this._audioCycle = setTimeout(() => {
        this.loadedAudioMetadata();
      }, 50);
    }
  }

  handleVideoDuration = () => {
    if (this._videoRef !== undefined && this._videoRef !== null) {
      let duration = this._videoRef.duration;
      // console.log("2- Setting a duration of", duration);
      clearTimeout(this._modalCycle);
      this._modalCycle = setTimeout(() => {
        // console.log("Closing Modal 2");
        this.setState({
          showModalVideo: false
        }, duration * 1000);
      });
    } else {
      this._modalCycle = setTimeout(() => {
        this.handleVideoDuration();
      }, 50);
    }
  }

  toggleSlideOff() {
    this.setState({
      displayNav: false
    })
  }

  toggleSlideOn() {
    this.setState({
      displayNav: true
    })
  }

  showModal() {
    let fileType = getFileType(this._assetFile);
    if (fileType === "video") {
      if (!this.state.showModalVideo) {
        this.setState({
          showModalVideo: true
        });
      }
    } else {
      if (!this.state.showModal) {
        this.setState({
          showModal: true
        });

        this._modalCycle = setTimeout(() => {
          this.setState({
            showModal: false
          });
        }, this._announcementTimeout)
      }
    }

    // Check for the audio asset
    if (this._audioAssetFile) {
      let audioFileType = getFileType(this._audioAssetFile);
      // console.log("2.- Filetype", audioFileType);
      if (audioFileType === "audio") {
        if (!this.state.playAudio) {
          this.setState({
            playAudio: true
          });
        }
      }
    }
  }

  toggleShowClock = (on) => {
    this.setState({
      showClock: on
    })
  }

  getActiveModuleType = () => {
    return this.props.content.dm_active[this.props.active_module].display_module_type
  }

  closeModal() {
    let fileType = getFileType(this._announcementAsset);
    if (fileType === "video") {
      if (this.state.showModalVideo) {
        this.setState({
          showModalVideo: false
        });
        clearTimeout(this._modalCycle);
      }
    } else {
      if (this.state.showModal) {
        this.setState({
          showModal: false
        });
        clearTimeout(this._modalCycle);
      }
    }
  }

  //pass the module ref as an option, when rendering story pass a story ref (typically 0) to ref which story
  navroute = (ref, type, source, options) => {
    // console.log("NAVROUTE", ref, type, source, options);
    let url;
    if (options.useFolders) {
      this._useFolders = true;
    }
    if (ref === null) {
      if (this.props.active_module !== undefined) {
        ref = this.props.active_module //maintain module if not changed
      }
    }
    if (type === null) {
      type = this.getActiveModuleType();
    }
    this.toggleSlideOff();
    this.setState({
      displayNav: false,
      options: options
    });
    this.props.setOptions(options);
    this.props.switchModule(ref);
    
    switch (type) {
      case "Home":
        this.setState({ showNav: true });
        this.props.history.replace("/");
        break;
      case "Story":
        this.setState({ showNav: true });
        this.props.history.replace("/story?id=" + ref);
        this.setNavBack(ref, type, source, options);
        break;
      case "Stories":
        this.setState({ showNav: true });
        this.props.history.replace("/stories?id=" + ref);
        this.setNavBack(ref, type, source, options);
        break;
      case "Stories Folders":
        url = "/stories_folders";
        url += "?id=" + ref; //getting set wrong from loop?
        if (options && options.donorId) {
          url += "&donor=" + options.donorId
        }
        if (source === "idle") {
          url += "&idle=true"
        }
        this.setState({ showNav: true });
        this.props.history.replace(url);
        this.setNavBack(ref, type, source, options);
        break;
      case "Donor List":
        url = "/donorlist";
        url += "?id=" + ref; //getting set wrong from loop?
        if (options && options.donorId) {
          url += "&donor=" + options.donorId
        }
        if (source === "idle") {
          url += "&idle=true"
        }
        this.setState({ showNav: true });
        this.props.history.replace(url);
        this.setNavBack(ref, type, source, options);
        break;
      case "User Input":
        this.setState({ showNav: true });
        this.props.history.replace("/userinput?id=" + ref);
        break;
      case "Input Confirmation":
        this.setState({ showNav: true });
        this.props.history.replace("/inputconfirmation");
        break;
      case "Slideshow":
        this.setState({ showNav: true });
        if (source === "idle") {
          let url = "/slideshow?id=" + options.idleModule; //ensures unique path
          this.props.history.replace(url);
        }
        else {
          this.props.history.replace("/slideshow?id=" + ref);
        }
        break;
      case "Search":
        this.setState({ showNav: true });
        this.props.history.replace("/search");
        break;
      case "Results":
        this.setState({ showNav: true });
        this.props.history.replace("/results");
        break;
      case "Timeline":
        this.setState({ showNav: true });
        this.props.history.replace("/timeline?id=" + ref);
        break;
      case "Donor Sea":
        this.setState({ showNav: true });
        this.props.history.replace("/donorsea");
        break;
      case "Recent Donors":
        this.setState({ showNav: true });
        if (source === "idle") {
          let url = "/recentdonors?id=" + options.idleModule; //ensures unique path
          this.props.history.replace(url);
        }
        else {
          this.props.history.replace("/recentdonors?id=" + ref);
        }
        break;
      default:
        break;
    }

    if (options && options.routeoverride !== undefined && options.routeoverride !== null) {
      this.props.history.replace(options.routeoverride);
    }
    // return(
    // <Redirect to={"/story+id="+ref}/>
    // )
  }

  folderNavroute = (ref, type, source, options) => {
    if (ref === null) {
      if (this.props.active_module !== undefined) {
        ref = this.props.active_module //maintain module if not changed
      }
    }
    if (type === null) {
      type = this.getActiveModuleType();
    }
    this.toggleSlideOff();
    this.setState({
      displayNav: false,
      options: options
    });
    // this.props.setOptions(options);
    this.props.switchModule(ref);

    let module;
    module = this._attractLoopTree.children[ref];
    this.setState({ showNav: true, module: module, attractLoopRef: ref });
    // this.props.history.replace("/attract_loop?id=" + ref);

    // if (options && options.routeoverride !== undefined && options.routeoverride !== null) {
    //   this.props.history.replace(options.routeoverride);
    // }
  }

  setNavBack(ref, type, source, options) {
    this.setState({
      navback: { ref: ref, type: type, source: source, options: options }
    })
  }

  navback() {
    if (!this.state.navback.ref) { //handle case where user has visited no other module that user input
      this.setState({
        navback: { ref: 0, type: this.props.content.dm_active[0].display_module_type, source: "navback", options: [] }
      })
      this.navroute(0, this.props.content.dm_active[0].display_module_type, "navback", []);
    }
    else {
      this.navroute(this.state.navback.ref, this.state.navback.type, this.state.navback.source, this.state.navback.options);
    }
  }

  renderLayer = (file, opacity, layer) => {
    let fullPath;
    let lower_layer_file_type;
    if (file) {
      lower_layer_file_type = getFileType(file.file_name);
      //fullPath = this.props.screen.dpath + file.path + file.file_name;
      fullPath = dpath(this.props.screen.mode, file.path, file.file_name, this.props.screen.webkey);
    }
    switch (lower_layer_file_type) {
      case "video":
        let vType = videoType(file.file_name);
        return (
          <div style={{ zIndex: -90, pointerEvents: "none", position: 'absolute', width: '100vw', height: '100vh' }}>
            <video className="nodrag" style={_videoStyle} id="background-video" loop autoPlay muted>
              <source src={fullPath} type={vType} />
              Your browser does not support the video tag.
            </video>
          </div>
        )
      case "image":
        return (
          <div className="noselect" style={{ zIndex: -90, pointerEvents: "none", position: 'absolute', width: '100vw', height: '100vh' }}>
            <img style={{ width: '100vw', height: '100vh', opacity: opacity }} src={fullPath} alt="Lower Layer Background" className="nodrag" />
          </div>
        )

      default:
        if (layer === "background") {
          return (
            <div className="noselect" style={{ backgroundColor: this.props.content.settings.lower_layer_color, zIndex: -90, pointerEvents: "none", position: 'absolute', width: '100vw', height: '100vh' }} />
          )
        }
        return (
          <span />
        )

    }
  }

  themeSwitch = (route) => {
    switch (route) {
      case "/timeline":
        switch (this.props.content.project.theme.name) {
          case "Chicago":
            return (
              //<Route path='/timeline' component={TimelineChicago} />
              <Route path='/timeline' render={props => <TimelineChicago {...props} toggleShowClock={this.toggleShowClock} resume={this.resume} navroute={this.navroute} options={this.state.options} />} />
            )
          case "Core":
          default:
            return (
              <Route path='/timeline' component={Timeline} />
            )
        }
      case "/userinput":
        switch (this.props.content.project.theme.name) {
          case "Core":
          default:
            return (
              <Route path='/userinput' render={props => <UserInput {...props} navroute={this.navroute} screen={this.props.screen} module={this.props.content.dm_active[this.props.active_module]} />} />
            )
        }

      case "/stories_folders":
        return (
          <Route path='/stories_folders' render={props => <StoriesFoldersChicago resume={this.resume} {...props} toggleShowClock={this.toggleShowClock} navroute={this.navroute} useFolders={this._useFolders} />} />
        );

      case "/donorlist":
        switch (this.props.content.project.theme.name) {
          case "Chicago":
            if (this.state.options.type === "simple") {
              return (
                <Route path='/donorlist' render={props => <DonorListChicagoSimple {...props} resume={this.resume} navroute={this.navroute} />} />
              )
            }
            return (
              <Route path='/donorlist' render={props => <DonorListChicago resume={this.resume} {...props} toggleShowClock={this.toggleShowClock} navroute={this.navroute} useFolders={this._useFolders} />} />
            )
          case "Core":
          default:

            //need logic here to go with interactive or non interactive
            let isIdle = parseStringParam(window.location.href, "idle");
            let mod = this.props.content.dm_active[this.props.active_module];
            if (isIdle === 'true') {

              mod = this.props.content.display_module_loops[0].display_module_loop_units[this.props.active_module].data; //.display_module.data    
            }
            if (!mod) {

              return (
                null
              )
            }
            let interactive = true;
            if (_.has(mod, "contents.interactive")) {
              interactive = mod.contents.interactive
            }
            if (interactive === true) {
              return (
                <Route path='/donorlist' render={props => <DonorList {...props} navroute={this.navroute} />} />
              )
            }
            else {
              return (
                <Route path='/donorlist' render={props => <DonorListPassive {...props} navroute={this.navroute} />} />
              )
            }

        }
      case "/story":
      default:
        switch (this.props.content.project.theme.name) {
          case "Chicago":
            return (
              <Route path='/story' component={Story} />
            )
          case "Core":
          default:
            return (
              <Route path='/story' component={Story} />
            )
        }
    }
  }

  pageClick = () => {
    this.resume();
  }

  checkRecentInteraction = () => {
    let msPassed = (new Date()).getTime() - this.lastInteraction.getTime();

    if (msPassed > recent_interaction_timeout) {
      this.goIdle("recentInteraction");
    }
    else {
      clearTimeout(this._recentInteractionTimeout);
      this._recentInteractionTimeout = setTimeout(() => {
        this.checkRecentInteraction();
      }, recent_interaction_timeout - msPassed); //avoids extra settings of timeout below interval check
    }
  }

  folderCheckRecentInteraction = () => {
    let msPassed = (new Date()).getTime() - this.lastInteraction.getTime();
    if (msPassed > recent_interaction_timeout) {
      this.folderGoIdle("recentInteraction");
    }
    else {
      clearTimeout(this._recentInteractionTimeout);
      this._recentInteractionTimeout = setTimeout(() => {
        this.folderCheckRecentInteraction();
      }, recent_interaction_timeout - msPassed); //avoids extra settings of timeout below interval check
    }
  }

  checkIdleTimeout = () => {
    let msPassed = (new Date()).getTime() - this.lastInteraction.getTime();
    if (msPassed > this._idleDelay) {
      if (this._attractLoopMode === FOLDER_ATTRACT) {
        this.folderGoIdle("idle");
      } else {
        this.goIdle("idle");
      }
    }
    else {
      clearTimeout(this._idleTimeout);
      this._idleTimeout = setTimeout(() => {
        this.checkIdleTimeout();
      }, this._idleDelay - msPassed); //avoids extra settings of timeout below interval check
    }

  }

  render() {
    if (!this.props.content.dm_active || !this.props.screen) {
      return <div>Loading ...</div>
    }

    const { location } = this.props;
    const key = this.props.location.pathname + this.props.location.search;
    let backgroundFile = this.renderLayer(this.props.content.settings.lower_layer_file, 1, 'background');
    let foregroundFile = this.renderLayer(this.props.content.settings.upper_layer_file, this.props.content.settings.upper_layer_opacity, 'foreground');
    let navClass = "";
    let backDropClass = "backdropOff";
    if (this.state.displayNav === true) {
      navClass += " on";
      backDropClass = "backdropOn";
    }

    const storiesWithProps = (props) => {
      return (
        <Stories
          categories={this.props.content.story_categories}
          navroute={this.navroute}
          {...props}
        />
      );
    }

    const folderStoriesWithProps = (props) => {
      // console.log(props);
      // return (<div></div>);
      return (
        <Stories
          categories={this.props.content.story_categories}
          navroute={this.navroute}
          useFolders={true}
          {...props}
        />
      );
    }

    const modalStyle = {
      position: 'absolute',
      height: this.props.screen.screenHeight,
      width: this.props.screen.screenWidth,
      // backgroundColor:'#a4bcc2',
      zIndex: 9999
    }

    const _videoStyle = {
      preload: 'auto',
      position: 'absolute',
      muted: "",
      objectFit: "fill",
      width: this.state.videoMaxWidth,
      height: this.state.videoMaxHeight,
    }

    const _btnStyle = {
      color: 'white',
      position:'absolute',
      fontSize: this.props.screen.screenHeight * 0.05,
      fontStyle:'normal',
      fontWeight: 'bold',
      textDecoration:'none',
      zIndex:9999
  }

    let cType = "";
    if (this.state.showModalVideo) {
      cType = videoType(this._announcementAsset);
    }

    return (
      <div className="noselect">
        {/*debug*/}
        {/*<div style={{ zIndex: 0, width: this.props.screen.r16_9.width, height: this.props.screen.screenHeight, left: this.props.screen.r16_9.left, top: 0, position: 'fixed', pointerEvents: 'none', backgroundColor: 'rgba(255, 255, 255, .2)' }} />*/}

        {(this.props.content.settings.showNav === undefined || this.props.content.settings.showNav === true) ?
          <NavButton showNav={this.state.showNav} recentInteraction={this.state.recentInteraction} animate={this.props.content.settings.animateNav} screen={this.props.screen} handleNavigationSlide={this.handleNavigationSlide} idle={this.state.idle} />
          :
          <span />}

        {
          this._attractLoopMode === FOLDER_ATTRACT ?
          <AttractLoopContainer tree={this._attractLoopTree} attractLoopRef={this.state.attractLoopRef} />
          : null
        }

        <CSSTransitionGroup
          component='div'
          transitionName='slowfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showModal}>
            {
              this.state.showModal ?
                <div style={{ ...modalStyle }}>
                  <a href="#" onClick={() => { this.closeModal() }} ref={el => this._closeModalRef = el} style={{ ..._btnStyle, top: this.state.closeModalBtnOffsetY, left: this.state.closeModalBtnOffsetX }}>X</a>
                  <img alt={"Announcement Modal"} style={{ position: 'absolute', width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }} src={this._announcementAsset} ref={el => this._imageModalRef = el} onLoad={this.handleImageLoaded.bind(this)} />
                </div>
                : null
            }
          </div>

          <div key={this.state.showModalVideo}>
            {
              this.state.showModalVideo ?
                <div style={{ ...modalStyle, backgroundColor: "black" }}>
                  {/* <a href="#" onClick={() => { this.closeModal() }} ref={el => this._closeModalRef = el} style={{ ..._btnStyle, top: this.state.closeModalBtnOffsetY, left: this.state.closeModalBtnOffsetX }}>X</a> */}
                  <video style={{ ..._videoStyle, top: this.state.videoOffsetY, left: this.state.videoOffsetX }} ref={el => this._videoModalRef = el} onLoadedMetadata={this.loadedMetadata.bind(this)} autoPlay>
                    <source src={this._announcementAsset} type={cType} />
                    Your browser does not support the video tag.
                  </video>
                </div>
                : null
            }
          </div>
        </CSSTransitionGroup>

        {
          this.state.playAudio ? 
          <audio ref={el => this._audioRef = el} src={this._announcementAudioAsset} onLoadedMetadata={this.loadedAudioMetadata.bind(this)} />
          : null
        }

        {(this.props.content.settings.custom_vars && this.props.content.settings.custom_vars.bottomnav === "true" && !this.props.content.settings.disallowInteraction) ?
          <div>
            <NavBottomFixed content={this.props.content} donors={this.props.donors} idle={this.state.idle} navroute={this.navroute} screen={this.props.screen} />
            <div style={{ left: this.props.screen.r16_9.left, pointerEvents: 'none', position: 'absolute', zIndex: 101, width: this.props.screen.r16_9.width, height: this.props.screen.screenHeight }}>
              <CSSTransitionGroup
                component='div'
                className="containerFade"
                style={{ minHeight: '100%' }}
                transitionName='example'
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}>
                <div key={this.state.idle}>
                  {this.state.idle ?
                    <div style={{ position: 'fixed', width: this.props.screen.r16_9.width, height: this.props.screen.r16_9.p10, bottom: 0, backgroundColor: '#a4bcc2' }}>
                      <div style={{ display: 'flex', alignItems: "center", width: this.props.screen.r16_9.width, height: '100%' }}>
                        <img alt="interact hand" src="/img/ui/interactbar_hand.png" style={{ position: 'absolute', left: this.props.screen.r16_9.p10, height: this.props.screen.r16_9.p10 * .4, width: this.props.screen.r16_9.p10 * .35 }} />
                        <span style={{ position: 'absolute', marginTop: this.props.screen.r16_9.p10 * .05, left: this.props.screen.r16_9.p10 * 2, fontFamily: 'Ostrich', fontSize: this.props.screen.r16_9.p10 * .6, color: '#496778' }}>TOUCH TO BEGIN</span>
                      </div>
                    </div>
                    :
                    <span />
                  }
                </div>
              </CSSTransitionGroup>

              <CSSTransitionGroup
                component='div'
                className="containerFade"
                style={{ minHeight: '100%' }}
                transitionName='example'
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}>
                <div key={this.state.showClock}>
                  {this.state.showClock ?
                    <InteractBottomFixed screen={this.props.screen} />
                    :
                    <span />
                  }
                </div>
              </CSSTransitionGroup>

              
            </div>
          </div> : <span />}

        <div className={this.props.content.font_class} style={{ color: this.props.content.settings.main_font_color }}>
          {backgroundFile}
          {foregroundFile}
          <div onMouseDown={this.toggleSlideOff} className={backDropClass} />
          <CSSTransitionGroup
            component='div'
            className="containerFade"
            transitionName="example"
            style={{ minHeight: "100%" }}
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <Switch key={key} location={location}>
              {/* <Route path='/story' component={Story} /> */}
              {this.themeSwitch('/story')}
              <Route path='/stories' render={storiesWithProps} />
              <Route path='/folder_stories' render={folderStoriesWithProps} />
              {this.themeSwitch('/userinput')}
              <Route path='/userinput' render={props => <UserInput {...props} navroute={this.navroute} screen={this.props.screen} module={this.props.content.dm_active[this.props.active_module]} />} />
              <Route path='/inputconfirmation' render={props => <InputConfirmation {...props} navback={this.navback} screen={this.props.screen} module={this.props.content.dm_active[this.props.active_module]} />} />
              <Route path='/slideshow' render={props => <Slideshow {...props} idle={this.state.idle} />} />
              <Route path='/recentdonors' render={props => <RecentDonors {...props} idle={this.state.idle} />} />
              {/* <Route path='/slideshow' component={Slideshow} /> */}
              {this.themeSwitch('/donorlist')}
              {this.themeSwitch('/stories_folders')}
              {this.themeSwitch('/timeline')}
              <Route path='/search' component={Search} />
              <Route path='/results' render={props => <Results {...props} navroute={this.navroute} />} />
              <Route path='/test' component={TestMin2} />
            </Switch>
          </CSSTransitionGroup>

          {/* {
            this.state.idle && this._attractLoopMode === FOLDER_ATTRACT ?
            <AttractLoopContainer tree={this._attractLoopTree} attractLoopRef={this.state.attractLoopRef} />
            : null
          } */}

          <div id="slideout" className={navClass}>
            <NavigationSide modules={this.props.content.dm_active} screen={this.props.screen} navroute={this.navroute} />
          </div>
        </div >
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  let active_module = state.active_module
  let namedmodule = shared.parseStringParam(window.location.href, "name");
  let idle = shared.parseStringParam(window.location.href, "idle");
  let route = shared.parseStringParam(window.location.href, "route");
  let jumpToModule = false;
  let routeoverride = null;

  if (namedmodule) {
    active_module = _.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
    if (active_module===-1){
      console.log({type: 'warning', message: 'A name query was provided but the named module was not found active on the display. Ensure a name match, that it is added to the display, that the display is set live, and that the data has been pulled to the client.'})
    }
    jumpToModule = true;
  }
  if (route) {
    routeoverride = route;
  }
  let idleActive = true;
  if (state.content.idle_delay === 0 || idle === "false") {
    idleActive = false;
  }

  // console.log(idleActive, jumpToModule, active_module);

  return {
    content: state.content,
    contentHasErrored: state.contentHasErrored,
    contentIsLoading: state.contentIsLoading,
    donors: state.donors,
    donorsHasErrored: state.donorsHasErrored,
    donorsIsLoading: state.donorsIsLoading,
    screen: state.screen,
    active_module: active_module,
    options: state.options,
    idleActive: idleActive,
    jumpToModule: jumpToModule,
    routeoverride: routeoverride
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    switchModule: (id) => dispatch(switchModule(id)),
    setOptions: (data) => dispatch(setOptions(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayContainer);



// WEBPACK FOOTER //
// ./src/containers/DisplayContainer.js